import React, { useState, useEffect }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../../tooling/formulaUtilsTooling';
import FormatTooling from '../../../../tooling/formatTooling';
import InterfaceTooling from '../../../../tooling/interfaceTooling';
import Constants from '../../../../definitions/constants';
import EngineFunctionsDefinition from '../../../../definitions/engineFunctionsDefinition';

import InMetricFakeFunctionParamsEditor from './objectInputs/inMetricFakeFunctionParamsEditor';

const FormulaInMetricFakeFunctionEditor = props => {
  const {
    dimensionsList,
    dimensionInstancesOptions,
    dimensionInstancesFetch,
    dimensionInstancesLoading,
    entity,
    entityOptions,
    onChange,
    handleGoToEditFormula,
    handleDeleteEntity,
    escBehaviourHandler,
    disabled,    
  } = props;
  let functionDefinition = (entity.name in EngineFunctionsDefinition.functionsList) ? EngineFunctionsDefinition.functionsList[entity.name] : null;
  let dimensionId = (entityOptions && entityOptions.dimension_id) ? entityOptions.dimension_id : null;
  let params = entity.childs.map(item => {
    return {
      type: item.type,
      value: (item.type==Constants.selectKeys.formulaEditor.metricParamTypes.FREE) ? 
        "" : (item.content.length>0 ? 
          (item.type==Constants.selectKeys.formulaEditor.metricParamTypes.CONTEXT_DIMENSION ? item.content[0].name : item.content[0]) : "")
    }
  });
  return (
    <div className="formula_editor_editor_entity_wrapper">
      <div className="formula_editor_editor_entity_label">
        {intl.formatMessage({id:"polynomialAdmin.formulaEditor.typeName." + entity.type + (entity.is_table ? "T" : "")}) + ": " + functionDefinition.label}
        {!disabled && (<span className="simulated-a" onClick={handleDeleteEntity}><FormattedMessage id="polynomialAdmin.formulaEditor.entityEditor.deleteEntity"/></span>)}
      </div>
      <div className="formula_editor_editor_entity_inner">
        <div className="formula_editor_editor_entity_inner_left">
          <InMetricFakeFunctionParamsEditor
            dimensionId={dimensionId}
            dimensionList={dimensionsList}
            dimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList, "name", "name")}
            typeOptions={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.inMetricParamTypes","polynomialAdmin.formulaEditor.entityEditor.paramTypesSelectValues")}
            dimensionInstancesOptions={dimensionInstancesOptions}
            dimensionInstancesFetch={dimensionInstancesFetch}
            dimensionInstancesLoading={dimensionInstancesLoading}
            values={params}
            onChange={onChange}
            handleGoToEditFormula={handleGoToEditFormula}
            className={(params.length==0) ? " has_error" : null}
            disabled={disabled}
            escBehaviourHandler={escBehaviourHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default FormulaInMetricFakeFunctionEditor;



// WEBPACK FOOTER //
// ./source/client/components/formulaEditor/entityEditors/formulaInMetricFakeFunctionEditor.jsx